"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const entity_ui_1 = require("@sierralabs/entity-ui");
const QueryFieldSelector_1 = __importDefault(require("./QueryFieldSelector"));
const EntitySelector = ({ value, 
// filter,
onChange }) => {
    const { entities } = (0, entity_ui_1.useEntityContext)();
    // const [entity, setEntity] = useState<EntitySchema>();
    // const filteredEntities = filter ? entities?.filter(filter) : entities;
    return (react_1.default.createElement(QueryFieldSelector_1.default, { className: 'entity-selector', placeholder: 'Select an Entity', value: value, options: entities || [], getOptionLabel: option => (option === null || option === void 0 ? void 0 : option.displayName) || '', onChange: onChange }));
};
exports.default = EntitySelector;
//# sourceMappingURL=EntitySelector.js.map